export const GET_ALL_EVENT = 'GET_ALL_EVENT';
export const GET_ALL_EVENT_SUCCESS = 'GET_ALL_EVENT_SUCCESS';
export const GET_ALL_EVENT_ERROR = 'GET_ALL_EVENT_ERROR';
export const GET_SINGLE_EVENT = 'GET_SINGLE_EVENT';
export const GET_SINGLE_EVENT_SUCCESS = 'GET_SINGLE_EVENT_SUCCESS';
export const GET_SINGLE_EVENT_ERROR = 'GET_SINGLE_EVENT_ERROR';
export const CREATE_EVENT = 'CREATE_EVENT';
export const CREATE_EVENT_SUCCESS = 'CREATE_EVENT_SUCCESS';
export const CREATE_EVENT_ERROR = 'CREATE_EVENT_ERROR';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const UPDATE_EVENT_SUCCESS = 'UPDATE_EVENT_SUCCESS';
export const UPDATE_EVENT_ERROR = 'UPDATE_EVENT_ERROR';
export const DELETE_EVENT = 'DELETE_EVENT';
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';
export const DELETE_EVENT_ERROR = 'DELETE_EVENT_ERROR';
// submit_event_general
export const SUBMIT_EVENT_GENERAL = 'submit_event_general';
export const SUBMIT_EVENT_GENERAL_SUCCESSFUL =
  'submit_event_general_successfull';
export const SUBMIT_EVENT_GENERAL_FAILED = 'submit_event_general_failed';

// submit_event_speackers_timing
export const SUBMIT_EVENT_SPEACKERS_TIMING = 'submit_event_speackers_timing';
export const SUBMIT_EVENT_SPEACKERS_TIMING_SUCCESSFUL =
  'submit_event_speackers_timing_successfull';
export const SUBMIT_EVENT_SPEACKERS_TIMING_FAILED =
  'submit_event_speackers_timing_failed';

// submit_event_lecture
export const SUBMIT_EVENT_LECTURE = 'submit_event_lecture';
export const SUBMIT_EVENT_LECTURE_SUCCESSFUL =
  'submit_event_lecture_successfull';
export const SUBMIT_EVENT_LECTURE_FAILED = 'submit_event_lecture_failed';
